import { gql } from "@apollo/client";

export const LOG_MISSING_TRANSLATION = gql`
  mutation addMissingTranslation($input: MissingTranslationInput!) {
    addMissingTranslation(input: $input)
  }
`;
